// extracted by mini-css-extract-plugin
export var callCard = "_i4-0";
export var callMessageButton = "_i4-1";
export var helpIcon = "_i4-3";
export var helpIconContainer = "_i4-4";
export var verticalDivider = "_i4-2";